<template>
    <p-card v-if="variant" :key="this.isNew">
        <b-card-title class="text-capitalize">{{ type }}</b-card-title>

        <b-row cols="1" cols-sm="2" cols-lg="4">
            <b-col>
                <p-input :model-value="variant.sku" label="SKU" :disabled="true">
                </p-input>
            </b-col>
            <b-col>
                <p-advanced-select
                    label="DCC"
                    name="DCC"
                    dataType="dcc"
                    :filter="2"
                    v-model.number="variant.dccId"
                    @change="dccChanged"
                    rules="required"
                    short-dropdown
                />
            </b-col>            
            <b-col>
                <p-input
                    label="Default Barcode"
                    name="Default Barcode"
                    v-model="variant.defaultBarcode"
                    :rules="isNew ? '' : 'required'"
                    :disabled="true"
                >
                    <template v-slot:append>
                        <b-button @click="openBarcodes">
                            <i class="fas fa-edit"></i>
                        </b-button>
                    </template>
                </p-input>
            </b-col>
            <b-col>
                <p-select
                    data-type="priceTagTypes"
                    label="Price Tag Type"
                    v-model="variant.priceTagTypeId"
                    rules="required"
                    :filter="2"
                >
                    <template v-slot:append>
                        <p-feature-flag name="Barcode Print">
                            <b-button
                                class="px-2"
                                style="white-space:nowrap;"
                                variant="outline-primary"
                                @click="showPrintLabel"
                            >Print Label</b-button>
                        </p-feature-flag>
                    </template>
                </p-select>
                <PrintLabel
                    v-if="
                        variant.priceTagTypeId &&
                            variant.defaultBarcode && variant.productInventoryId > 0
                    "
                    :product="variant"
                    :type="type"
                    ref="printLabelModalBook"
                />
            </b-col>
            <b-col v-if="variant.isPhysical">
                <p-advanced-select
                    data-type="suppliers"
                    label="Supplier"
                    v-model="variant.supplierId"
                    @change="$emit('supplier-changed')"
                    rules="required" />
            </b-col>
            <b-col v-else>
                <p-input
                    label="Supplier"
                    :model-value="'N/A'"
                    :disabled="true"
                    name="supplierId"
                />
            </b-col>
            <b-col v-if="variant.isPhysical">
                <p-select
                    label="Supplier Discounts"
                    :options="filteredSupplierDiscountCodes"
                    v-model="variant.vendorDiscountCodeId"
                    text-field="text"
                    add-empty-option />
            </b-col>
            <b-col v-if="variant.isPhysical">
                <p-select
                    data-type="textStatus"
                    label="Buyer's Guide Status"
                    :model-value="textStatusId"
                    @input="$emit('update:textStatusId', $event)"
                />
            </b-col>
            <b-col v-if="variant.isPhysical">
                <p-datepicker
                    label="Buyer's Guide Status Date"
                    :model-value="textStatusDate"
                    @input="$emit('update:textStatusDate', $event)"
                />
            </b-col>

            <b-col v-if="!variant.isPhysical">
                <p-input
                    label="Catalog"
                    :model-value="variant.catalog"
                    :disabled="true"
                />
            </b-col>
            <b-col v-if="!variant.isPhysical">
                <p-input
                    label="Product Code"
                    :model-value="variant.productCode"
                    :disabled="true"
                />
            </b-col>
            <b-col v-if="!variant.isPhysical">
                <p-input
                    label="Duration"
                    :model-value="variant.duration"
                    :disabled="true"
                />
            </b-col>

        </b-row>
        <b-row cols="5" class="mb-3">
            <b-col v-if="variant.isPhysical">
                <p-input :model-value="variant.onOrder" label="On Order" disabled ></p-input>
            </b-col>
            <b-col v-if="variant.isPhysical"
                ><p-number
                    input-type="integer"
                    name="SOH"
                    readonly
                    label="Stock on Hand"
                    v-model.number="variant.stockOnHand"
                >
                    <template v-slot:append>
                        <b-button @click="sohModal" style="white-space:nowrap;"
                            >Adjust SOH</b-button
                        >
                    </template>
                </p-number>
            </b-col>
            <b-col v-if="!variant.isPhysical" style="padding-top: 25px;">
                <b-row>
                    <b-col cols="auto">
                        <p-checkbox
                            label="Active"
                            :use-switch="true"
                            v-model="variant.isActive"
                            @change="checkDigitalAvailability"
                            size="md" />
                    </b-col>
                    <b-col cols="auto">
                        <p-checkbox
                            label="IA/EA Only"
                            :use-switch="true"
                            v-model="variant.iaeaOnly"
                            size="md" />
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-if="!variant.isPhysical">
                <p-input
                    label="Digital ISBN"
                    :model-value="digitalIsbn"
                    :disabled="true"
                />
            </b-col>
            <b-col v-if="variant.isPhysical">
                <p-number
                    input-type="money"
                    name="Cost"
                    label="Cost"
                    v-model.number="variant.cost"
                    rules="required|min_value:0"
                    @change="calculateMargin()"
                    left-align
                >
                    <template v-slot:append>
                        <p-button
                            v-if="variant.isPhysical"
                            type="button"
                            @click="showAccountingCostUpdater()"
                        >
                            <i class="fas fa-redo"></i>
                        </p-button>
                    </template>
                </p-number>
            </b-col>
            <b-col v-if="variant.isPhysical">
                <p-number
                    input-type="percent"
                    disabled="disabled"
                    label="Current Margin"
                    v-model.number="variant.margin"
                    left-align
                />
            </b-col>
            <b-col>
                <p-number
                    input-type="money"
                    name="Retail"
                    label="Selling Price"
                    v-model.number="variant.retail"
                    rules="required|min_value:0"
                    @change="calculateMargin()"
                    left-align>
                    <template v-slot:append>
                        <p-button
                            v-if="type !== 'digital'"
                            type="button"
                            @click="showCalculator()">
                            <i class="fas fa-calculator"></i>
                        </p-button>
                    </template>
                </p-number>
            </b-col>
        </b-row>
        <b-row v-if="variant.isPhysical">
            <b-col cols="8">
                <b-row class="mt-2 mb-4 mx-2">
                    <b-col cols="auto">
                        <p-checkbox
                            label="Buyback Title"
                            v-model="variant.isBuybackTitle"
                            :disabled="type === 'trade'"
                        />
                    </b-col>
                    <b-col cols="auto">
                        <p-checkbox
                            label="Wantlist Title"
                            v-model="variant.isWantlistTitle"
                            :disabled="type === 'trade'"
                        />
                    </b-col>
                    <b-col cols="auto">
                        <p-checkbox
                            label="Discontinued"
                            v-model="variant.isDiscontinued"
                        />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="4">
                  <strong>Last Sold: </strong>
                  <span v-if="variant.lastSold && !isNewVariant">
                      {{ dateFormatter(variant.lastSold) }}
                      {{ datetimeToLocalTimeOnlyFormatter(variant.lastSold) }}
                  </span>
                <span v-else>N/A</span>
                  
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="variant.sku">
                <p-secure :require-role="[SECURITYROLES.MERCHANDISEMANAGER]">
                    <b-button
                        class="text-capitalize"
                        :name="type + '-delete-button'"
                        variant="outline-danger"
                        @click="deleteProduct"
                    >
                        Delete {{ type }}
                    </b-button>
                </p-secure>
            </b-col>
            <b-col v-else-if="type == 'new'"></b-col>
            <b-col v-else>
                <b-button variant="outline-primary" @click="removeVariant"
                    ><b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise>
                    Undo</b-button
                >
            </b-col>
        </b-row>
        <PriceCalculator
            :name="`${type}variantPriceCalculator`"
            :initial-values="variant"
            :parameters="parameters"
            @apply="applyPricing">
        </PriceCalculator>
        <AccountingCostUpdater
            :name="`${type}variantAccountingCostUpdater`"
            :initial-values="variant"
            :parameters="parameters"
            @ok="$emit('clearDirtyFlag')">
        </AccountingCostUpdater>
    </p-card>
</template>

<script>
import axios from 'axios';
import PrintLabel from './PrintLabel.vue';
import PriceCalculator from './PriceCalculator.vue';
import pricing from '@/services/PricingCalculations.js';
import AccountingCostUpdater from './AccountingCostUpdater.vue';
import { dateFormatter, datetimeToLocalTimeOnlyFormatter } from '@/components/Common/Formatters.js';

export default {
    props: {
        variant: Object,
        parameters: Object,
        type: String,
        isNewVariant: Boolean,
        digitalIsbn: String,
        supplierDiscountCodes: {
            type: Array,
            default: () => []
        },
        textStatusId: {
            type: [Number, String],
            default: null
        },
        textStatusDate: {
            type: [String, Date],
            default: null
        }        
    },
    data() {
        return {
            barcode: null
        };
    },
    methods: {
        dateFormatter: dateFormatter,
        datetimeToLocalTimeOnlyFormatter: datetimeToLocalTimeOnlyFormatter,
        async showPrintLabel(){
            if(this.variant.priceTagTypeId && this.variant.defaultBarcode && this.variant.productInventoryId == 0 || this.variant.productInventoryId == null){
                await this.$bvModal
                    .msgBoxOk(
                        'You must save the product before you can print this label.'
                    )
            }else if(this.variant.priceTagTypeId && this.variant.defaultBarcode && this.variant.productInventoryId > 0){
                this.$emit('savePage',this.type);
            }
        },
        sohModal() {
            if (this.variant.isPhysical) {
                this.$emit('sohModal', this.variant);
            }
        },
        removeVariant() {
            this.$emit('removeVariant', this.type);
        },
        openBarcodes() {
            this.$emit('openBarcodes', this.variant);
        },
        dccChanged() {
            this.$emit('dccChanged', this.variant);
        },
        forceUpdate() {
            this.$forceUpdate();
        },
        calculateMargin() {
            this.variant.margin = pricing.computeMargin(
                this.variant.cost,
                this.variant.retail);
        },
        deleteProduct() {
            this.$emit('deleteVariant');
        },
        checkDigitalAvailability() {
            this.$nextTick(() => {
                // Only perform check when being toggled to active
                if (this.variant.isActive && !this.variant.isPhysical && this.digitalIsbn) {
                    axios.get('/products/checkdigitalavailable', {
                        params: { isbn: this.digitalIsbn, sku: this.variant.sku }
                    })
                    .then(response => {
                        this.$emit('updateDigitalStatus', response.data.isAvailable == true);

                        if (!response.data.isAvailable) {
                            // Toggle back to inactive if not available
                            this.variant.isActive = false;
                            
                            this.$bvModal.msgBoxOk(
                                `This digital book (ISBN: ${this.digitalIsbn}) cannot be activated. Status is not active with the provider or the ISBN no longer exists in their catalog.`,
                                { title: 'Digital Book Unavailable', okTitle: 'OK' });
                        }                        
                    })
                    .catch (() => this.$appError('Failed to check digital book availability.'));
                }
            });
        },
        showAccountingCostUpdater() {
            this.variant.accountingCost = this.variant.accountingCost == null ?  0.00 : this.variant.accountingCost;
            setTimeout(() => {
                this.$bvModal.show(`${this.type}variantAccountingCostUpdater`)
            }, 50);
        },
        showCalculator() {
            setTimeout(() => {
                this.$bvModal.show(`${this.type}variantPriceCalculator`)
            }, 50);
        },
        applyPricing(pricing) {
            if (this.variant) {
                this.variant.cost = pricing.cost;
                this.variant.retail = pricing.retail;
                this.variant.margin = pricing.margin;
            }
        }
    },
    computed: {
        isNew() {
            return !this.variant.sku;
        },
        filteredSupplierDiscountCodes() {
            if (!this.variant.supplierId || !this.supplierDiscountCodes) return [];
            const match = this.supplierDiscountCodes.find(
                code => code.supplierId === this.variant.supplierId
            );
            return match && match.shippingDiscountCodes ? match.shippingDiscountCodes : [];
        }     
    },
    components: {
        PrintLabel,
        PriceCalculator,
        AccountingCostUpdater
    }
};
</script>

